// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeNotificationSettingsGetGlobalBody = {};

export type typeNotificationSettingsGetGlobalOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    alerts: {
      alertKind:
        | "poolInvite"
        | "contestStarted"
        | "contestFinished"
        | "seasonStarted"
        | "poolSettingsChanged"
        | "pickReminder"
        | "roundGraded"
        | "eliminated"
        | "revived"
        | "spreadMoved"
        | "customAwardChanged"
        | "squaresLockUnlock"
        | "squaresGridPublished"
        | "squaresWinnerSet"
        | "squaresWinnerUpdated"
        | "squaresSquareAssigned"
        | "squaresScoreCorrection"
        | "stripCardLockUnlock"
        | "memberWaitingApproval"
        | "gameStart"
        | "gameEnd"
        | "gameMoment"
        | "chatMessage"
        | "chatReaction"
        | "messageRequest"
        | "chatClosed"
        | "roundLocked"
        | "contestCorrected"
        | "stripCardStripAdded"
        | "stripCardFilled"
        | "stripCardSpotAssigned"
        | "stripCardSpotUnassigned"
        | "stripCardWinner"
        | "stripCardGameCanceled"
        | "fanFollowRequest"
        | "fanFollowNew"
        | "fanFollowAccepted";
      group: "invite" | "pools" | "games" | "chat";
      email: { isEnabled: boolean; isLocked: boolean };
      inApp: { isEnabled: boolean; isLocked: boolean };
      phone: { isEnabled: boolean; isLocked: boolean };
    }[];
    isEmailKillSwitchOn: boolean;
    activePresetId?: "everything" | "essentials" | "quiet" | null;
    presets: {
      presetId: "everything" | "essentials" | "quiet";
      label: string;
      description: string;
    }[];
  };
};

export type typeNotificationSettingsGetGlobalOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeNotificationSettingsGetGlobalOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeNotificationSettingsGetGlobalOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaNotificationSettingsGetGlobalBody = {
  type: "object",
  properties: {},
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createNotificationSettingsGetGlobal(
  options: SdkOptions,
) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaNotificationSettingsGetGlobalBody);
  }

  return async function postNotificationSettingsGetGlobal(
    payload: typeNotificationSettingsGetGlobalBody,
  ): Promise<
    | typeNotificationSettingsGetGlobalOutput200
    | typeNotificationSettingsGetGlobalOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postNotificationSettingsGetGlobal" failed before calling the network. #51721464d41a`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#51721464d41a" },
        },
        data: null,
      } as typeNotificationSettingsGetGlobalOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/notification-settings/get-global`,
      httpMethod: "POST",
      options,
    })) as
      | typeNotificationSettingsGetGlobalOutput200
      | typeNotificationSettingsGetGlobalOutput400;
  };
}
